var _defs, _circle, _circle2, _circle3, _circle4, _g, _g2, _g3, _rect, _rect2, _g4, _rect3, _rect4, _rect5, _g5, _line, _circle5, _circle6, _g6, _line2, _g7, _rect6, _rect7, _rect8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ringGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ff7a18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "35%",
    stopColor: "#ff5500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#e83a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#c92800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "innerBg",
    cx: "42%",
    cy: "38%",
    r: "70%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fffaf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#fdeee4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fbe0cf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "micGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffb347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "#ff6a1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#d83400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "micHighlight",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffd98a",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45%",
    stopColor: "#ffb347",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffb347",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "radioGrad",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ff7a2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#e23a00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dialFace",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fff3e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffd9b8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "knobGrad",
    cx: "38%",
    cy: "35%",
    r: "70%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ff8a3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#ff3d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#c52000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gloss",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffd9a0",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "#ffd9a0",
    stopOpacity: 0
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 430,
    fill: "url(#ringGrad)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 430,
    fill: "url(#gloss)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 340,
    fill: "url(#innerBg)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 350,
    fill: "none",
    stroke: "#ffb066",
    strokeWidth: 6,
    strokeOpacity: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#ff5a1a",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 360 270 Q 300 400 360 540",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 300 320 Q 255 410 300 510",
    strokeWidth: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 250 360 Q 220 415 250 480",
    strokeWidth: 16
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#ff5a1a",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 664 270 Q 724 400 664 540",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 724 320 Q 769 410 724 510",
    strokeWidth: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 774 360 Q 804 415 774 480",
    strokeWidth: 16
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "url(#micGrad)",
    stroke: "#c22e00",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 370,
    width: 34,
    height: 80,
    rx: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598,
    y: 370,
    width: 34,
    height: 80,
    rx: 16
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 424,
    y: 225,
    width: 176,
    height: 290,
    rx: 88,
    fill: "url(#micGrad)",
    stroke: "#b82a00",
    strokeWidth: 6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 438,
    y: 240,
    width: 70,
    height: 262,
    rx: 35,
    fill: "url(#micHighlight)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    stroke: "#a82500",
    strokeWidth: 9,
    strokeLinecap: "round",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("line", {
    x1: 446,
    y1: 290,
    x2: 578,
    y2: 290
  }), /*#__PURE__*/React.createElement("line", {
    x1: 446,
    y1: 324,
    x2: 578,
    y2: 324
  }), /*#__PURE__*/React.createElement("line", {
    x1: 446,
    y1: 358,
    x2: 578,
    y2: 358
  }), /*#__PURE__*/React.createElement("line", {
    x1: 446,
    y1: 392,
    x2: 578,
    y2: 392
  }), /*#__PURE__*/React.createElement("line", {
    x1: 446,
    y1: 426,
    x2: 578,
    y2: 426
  }), /*#__PURE__*/React.createElement("line", {
    x1: 446,
    y1: 460,
    x2: 578,
    y2: 460
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 482,
    y: 510,
    width: 60,
    height: 60,
    rx: 10,
    fill: "url(#micGrad)",
    stroke: "#b82a00",
    strokeWidth: 5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 560,
    width: 424,
    height: 150,
    rx: 22,
    fill: "url(#radioGrad)",
    stroke: "#b82a00",
    strokeWidth: 7
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 588,
    width: 280,
    height: 56,
    rx: 12,
    fill: "url(#dialFace)",
    stroke: "#c43000",
    strokeWidth: 4
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    stroke: "#d83a00",
    strokeWidth: 3,
    strokeLinecap: "round",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("line", {
    x1: 356,
    y1: 600,
    x2: 356,
    y2: 612
  }), /*#__PURE__*/React.createElement("line", {
    x1: 372,
    y1: 600,
    x2: 372,
    y2: 612
  }), /*#__PURE__*/React.createElement("line", {
    x1: 388,
    y1: 600,
    x2: 388,
    y2: 612
  }), /*#__PURE__*/React.createElement("line", {
    x1: 404,
    y1: 600,
    x2: 404,
    y2: 612
  }), /*#__PURE__*/React.createElement("line", {
    x1: 420,
    y1: 600,
    x2: 420,
    y2: 612
  }), /*#__PURE__*/React.createElement("line", {
    x1: 436,
    y1: 600,
    x2: 436,
    y2: 612
  }), /*#__PURE__*/React.createElement("line", {
    x1: 452,
    y1: 600,
    x2: 452,
    y2: 612
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 600,
    x2: 500,
    y2: 612
  }), /*#__PURE__*/React.createElement("line", {
    x1: 516,
    y1: 600,
    x2: 516,
    y2: 612
  }), /*#__PURE__*/React.createElement("line", {
    x1: 532,
    y1: 600,
    x2: 532,
    y2: 612
  }), /*#__PURE__*/React.createElement("line", {
    x1: 548,
    y1: 600,
    x2: 548,
    y2: 612
  }), /*#__PURE__*/React.createElement("line", {
    x1: 564,
    y1: 600,
    x2: 564,
    y2: 612
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 600,
    x2: 580,
    y2: 612
  }), /*#__PURE__*/React.createElement("line", {
    x1: 596,
    y1: 600,
    x2: 596,
    y2: 612
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 478,
    y1: 596,
    x2: 478,
    y2: 636,
    stroke: "#ff3d00",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 668,
    cy: 616,
    r: 30,
    fill: "url(#knobGrad)",
    stroke: "#a82200",
    strokeWidth: 4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 660,
    cy: 608,
    r: 8,
    fill: "#ffd9a0",
    opacity: 0.7
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffe1b0",
    stroke: "#c43000",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 356,
    cy: 678,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 392,
    cy: 678,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 428,
    cy: 678,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 464,
    cy: 678,
    r: 13
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 678,
    x2: 568,
    y2: 678,
    stroke: "#c43000",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffe1b0",
    stroke: "#c43000",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 604,
    cy: 678,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 640,
    cy: 678,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 676,
    cy: 678,
    r: 13
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 710,
    width: 384,
    height: 22,
    rx: 6,
    fill: "#d83400",
    stroke: "#a82200",
    strokeWidth: 4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 710,
    width: 20,
    height: 34,
    fill: "#c42e00"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 710,
    width: 20,
    height: 34,
    fill: "#c42e00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.abd5272ee70e99ed1b413e1248c471b4.svg";
export { ForwardRef as ReactComponent };